/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, ViewEncapsulation} from '@angular/core';

import template from './base-new-button.component.html';
import {AppShellStateService} from '../app-shell-state.service';

@Component({
  standalone: false,
  selector: 'adn-base-new-button',
  template,
  encapsulation: ViewEncapsulation.None
})
export class BaseNewButtonComponent {
  constructor(readonly shell: AppShellStateService) {
  }

  loadExternalLineItem(): void {
    this.shell.loadExternalLineItem();
  }
}
